export async function loadParallaxMover(engine, refresh = true) {
    await engine.addMover("parallax", async () => {
        const { ParallaxMover } = await import("./ParallaxMover.js");
        return new ParallaxMover();
    }, refresh);
}
